import CouncilViewPage from "./CouncilViewPage";

export default CouncilViewPage;
